<template>
  <div id="wrap">
    <!-- logo -->
    <div class="logo"></div>
    <!-- title -->
    <div class="title">轻松换</div>
    <div
      class="text"
    >轻松换是同城帮旗下的以旧换新平台，为用户提供一站式以旧换新服务，带来创新购新体验。</div>
    <!-- 格子区域 -->
    <div class="lattice">
      <div class="top">
        <div class="left">前台</div>
        <div class="right">
          <div class="right-top">
            <div></div>
            <div></div>
          </div>
          <div class="right-bottom">
            <div>前端流量分发</div>
            <div>旧机评估系统</div>
          </div>
        </div>
        <img class="one" src="../../assets/imgs/product/hx.png" alt />
        <img class="two" src="../../assets/imgs/product/hx.png" alt />
        <img class="three" src="../../assets/imgs/product/hr.png" alt />
        <img class="four" src="../../assets/imgs/product/hx.png" alt />
        <img class="five" src="../../assets/imgs/product/ls.png" alt />
      </div>
      <div class="content">
        <div class="left">
          同
          <br />城
          <br />帮
          <br />中
          <br />台
        </div>
        <div class="right">
          <div>新机SKU库存系统，旧机数据中台</div>
          <div>订单中台</div>
          <div>
            <div class="left">天机汇云仓</div>
            <div class="right">同城帮仓储系统</div>
          </div>
        </div>
        <img class="one" src="../../assets/imgs/product/lx.png" alt />
        <img class="two" src="../../assets/imgs/product/lx.png" alt />
        <img class="three" src="../../assets/imgs/product/lx.png" alt />
        <img class="four" src="../../assets/imgs/product/lx.png" alt />
      </div>
      <div class="bottom">
        <div class="left">后端</div>
        <div class="right">单货分发系统</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style lang="scss"  scoped>
#wrap {
  .logo {
    width: 64px;
    height: 64px;
    background-image: url("https://p0.ssl.qhimg.com/t01627b2470406dff3d.png");
    background-size: cover;
    background-repeat: no-repeat;
    margin-bottom: 30px;
  }
  .title {
    color: #000000;
    font-size: 30px;
    font-weight: 600;
    margin-bottom: 40px;
  }
  .text {
    line-height: 28px;
    font-size: 16px;
    margin-bottom: 60px;
  }
  .lattice {
    width: 1034px;
    color: white;
    font-size: 18px;
    text-align: center;
    line-height: 82px;
    font-weight: 600;
    margin-bottom: 70px;
    letter-spacing: 2px;
    .top {
      height: 232px;
      width: 100%;
      display: flex;
      position: relative;
      .left {
        width: 135px;
        height: 232px;
        background-color: #cf2c28;
        margin-right: 18px;
        text-align: center;
        line-height: 232px;
      }
      .right {
        width: 883px;
        height: 82px;
        .right-top {
          width: 100%;
          height: 82px;
          display: flex;
          justify-content: space-between;
          margin-bottom: 68px;
          div {
            width: 406px;
            height: 82px;
            background-size: cover;
            background-repeat: no-repeat;
          }
          div:nth-child(1) {
            background-image: url("../../assets/imgs/product/tm.png");
          }
          div:nth-child(2) {
            background-image: url("../../assets/imgs/product/xy.png");
          }
        }
        .right-bottom {
          width: 100%;
          height: 82px;
          display: flex;
          justify-content: space-between;
          margin-bottom: 68px;
          div {
            width: 406px;
            height: 82px;
            background-color: #cf2c28;
          }
        }
      }
      img {
        width: 17px;
        height: 57px;
        position: absolute;
      }
      .one {
        left: 350px;
        top: 88px;
      }
      .two {
        left: 824px;
        top: 88px;
      }
      .three {
        left: 564px;
        top: 185px;
        width: 57px;
        height: 17px;
      }
      .four {
        right: 212px;
        bottom: -64px;
      }
      .five {
        right: 175px;
        bottom: -64px;
      }
    }
    .content {
      margin: 70px 0;
      height: 387px;
      width: 100%;
      display: flex;
      position: relative;
      .left {
        width: 135px;
        height: 387px;
        background-color: #26c9a5;
        display: flex;
        justify-content: center;
        align-items: center;
        line-height: 20px;
        margin-right: 18px;
      }
      .right {
        width: 883px;
        height: 387px;
        div {
          width: 100%;
          height: 82px;
          background-color: #26c9a5;
        }
        div:nth-child(2) {
          margin: 70px 0;
        }
        div:nth-child(3) {
          background-color: #fff;
          display: flex;
          .right,
          .left {
            width: 430px;
            height: 82px;
          }
          .right {
            margin: 0;
            margin-left: 22px;
          }
        }
      }
      img {
        width: 17px;
        height: 57px;
        position: absolute;
      }
      .one {
        left: 584px;
        top: 90px;
      }
      .two {
        left: 353px;
        top: 242px;
      }
      .three {
        left: 815px;
        top: 242px;
      }
      .four {
        left: 584px;
        bottom: -64px;
      }
    }
    .bottom {
      width: 100%;
      height: 82px;
      display: flex;
      .left {
        width: 135px;
        height: 82px;
        background-color: #478aff;
        margin-right: 18px;
      }
      .right {
        width: 883px;
        height: 82px;
        background-color: #478aff;
      }
    }
  }
}
</style>
